import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import avtar from '../../assets/images/user.png'
import avtar2 from '../../assets/images/avtar.png'
import socket from '../socket/socket';
import axios from 'axios';
import MobileBottomBar from '../Layout/MobileBottomBar';

function Chat() {
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const location = useLocation();
    const orderID = location?.state?.orderId
    const senderId = JSON.parse(localStorage.getItem("user"));
    const [selectedFile, setSelectedFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const fileInputRef = useRef(null);
    const chatTo = "customer-support";
    const initialMessage = location?.state?.initialMessage;
    const [hasSentInitialMessage, setHasSentInitialMessage] = useState(false);
    const hasSentInitialMessageRef = useRef(false);

    // Get sender profile from messages (for consistency with chat messages)
    // Find the first message where sender_id matches current user to get the profile from API
    const senderProfileFromMessages = messages.find(msg => msg.sender_id === senderId?.id)?.sender_profile;
    // Use profile from messages if available, otherwise fallback to localStorage
    const displayProfile = senderProfileFromMessages || senderId?.profile;

    // Get existing messages from API
    const fetchChatHistory = async () => {
        try {
            const res = await axios.post('https://fynito.com/message/message-get', { order_id: orderID, chat_to: chatTo });
            if (res.data.status_code === 200 && res.data.data) {
                setMessages(res.data.data);
                return res.data.data; // Return messages for checking
            }
            return [];
        } catch (error) {
            console.error("Failed to load chat history", error);
            return [];
        }
    };

    useEffect(() => {
        const initializeChat = async () => {
            // First, fetch existing chat history
            const existingMessages = await fetchChatHistory();
            
            // Check if we need to send initial message
            if (initialMessage && !hasSentInitialMessageRef.current) {
                const trimmedMessage = initialMessage.trim();
                
                // Check if the initial message already exists in the fetched messages
                const messageExists = existingMessages.some(msg => 
                    msg.message === trimmedMessage && 
                    msg.sender_id === senderId?.id
                );
                
                // Only send if it doesn't already exist
                if (!messageExists && trimmedMessage) {
                    hasSentInitialMessageRef.current = true;
                    const messageData = {
                        order_id: orderID,
                        from: "user",
                        chat_to: chatTo,
                        sender_id: senderId?.id,
                        support_team_id: "",
                        message: trimmedMessage,
                        file: "",
                    };
                    socket.emit('sendMessage', `${orderID}_${chatTo}`, messageData);
                } else {
                    hasSentInitialMessageRef.current = true; // Mark as handled even if not sent
                }
            }
        };
        
        if (orderID && chatTo) {
            initializeChat();
        }
    }, [orderID, chatTo, initialMessage]);
    

  
    useEffect(() => {
        if (!orderID || !chatTo) return;
        socket.emit('joinRoom', `${orderID}_${chatTo}`);

        socket.on('receiveMessage', (data) => {
            setMessages(prev => {
                // Check if message already exists to prevent duplicates
                // Compare by message content, sender_id, and created_at timestamp
                const messageExists = prev.some(msg => 
                    msg.id === data.id || 
                    (msg.message === data.message && 
                     msg.sender_id === data.sender_id && 
                     msg.created_at === data.created_at)
                );
                
                if (messageExists) {
                    return prev; // Don't add duplicate
                }
                return [...prev, data];
            });
        });

        return () => {
            socket.off('receiveMessage');
        };
    }, [orderID, chatTo]);

    // File Remove
    const removeSelectedFile = () => {
        setSelectedFile(null);
        setFilePreview('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    //  Handle File upload
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);

            // Create a preview for the file
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = () => {
                    setFilePreview(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                // For non-image files, just show the filename
                setFilePreview(file.name);
            }
        }
    }

    // Send Message Via Socket
    const sendMessage = () => {
        const trimmedMessage = message.trim();
        // Case 1: Only message
        if (trimmedMessage && !selectedFile) {
            const messageData = {
                order_id: orderID,
                from: "user",
                chat_to: chatTo,
                sender_id: senderId?.id,
                support_team_id: "",
                message: trimmedMessage,
                file: "",
            };
            socket.emit('sendMessage', `${orderID}_${chatTo}`, messageData);
            setMessage('');
            return;
        }

        // Case 2: File selected (with or without message)
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64File = reader.result.split(',')[1];
                const messageData = {
                    order_id: orderID,
                    from: "user",
                    chat_to: chatTo,
                    sender_id: senderId?.id,
                    support_team_id: "",
                    message: trimmedMessage,
                    file: base64File,
                };
                socket.emit('sendMessage', `${orderID}_${chatTo}`, messageData);
                // Reset everything
                setMessage('');
                setSelectedFile(null);
                setFilePreview('');
                if (fileInputRef.current) fileInputRef.current.value = '';
            };

            reader.readAsDataURL(selectedFile);
        }
    };
    


    return (
        <>
            <section className="innr-page-banner">
                <div className="container">
                    <h1 className="text-center text-white">Chat</h1>
                </div>
            </section>
            <section className="chat-sec tp-space">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="chat-card">
                                <div className="chat-header">
                                    <div className="chat-header-lft">
                                        <img src={displayProfile || avtar} alt="avtar" />
                                        <div className="chat-header-lft-content">
                                            <h5>{senderId?.name}</h5>
                                            <p>
                                                <span className="online" />
                                                Online
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <Link to="/support" className="end-btn">
                                            End Chat
                                        </Link>
                                    </div>
                                </div>
                                <div className="chat-body">
                                    <ul className="message-bx">
                                        {messages.map((msg, index) => {
                                            // Determine if message is from current user by comparing sender_id
                                            // If sender_id matches current user's ID, it's a message sent by the user (right side)
                                            // Otherwise, it's a message from support team (left side)
                                            const isCurrentUser = msg.sender_id === senderId?.id;
                                            const isImage = msg.file?.match(/\.(jpeg|jpg|png|gif|webp)$/i);

                                            return (
                                                <li key={index} className={isCurrentUser ? 'right' : 'left'}>
                                                    {/* Show sender profile on left for support messages */}
                                                    {!isCurrentUser && <img src={msg.sender_profile || avtar} alt="avtar" />}
                                                    <div>
                                                        {msg.message && <p className="text">{msg.message}</p>}

                                                        {msg.file && (
                                                            <div className="file-attachment">
                                                                {isImage ? (
                                                                    <img
                                                                        src={msg.file}
                                                                        alt="attachment"
                                                                        style={{ maxWidth: '200px', borderRadius: '4px', marginTop: '5px' }}
                                                                    />
                                                                ) : (
                                                                    <a
                                                                        href={msg.file}
                                                                        download={msg.fileName || "attachment"}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ display: 'inline-flex', alignItems: 'center', marginTop: '5px' }}
                                                                    >
                                                                        <i className="fas fa-file" style={{ marginRight: '6px' }}></i>
                                                                        {msg.fileName || 'Download File'}
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* Show sender's profile on right for user's own messages - use sender_profile from API for consistency */}
                                                    {isCurrentUser && <img src={msg.sender_profile || senderId?.profile || avtar2} alt="avtar2" />}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className="chat-footer">
                                    <input
                                        type="file"
                                        style={{ display: 'none' }}
                                        id="file-upload"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                    />
                                    <label htmlFor="file-upload" className="link-btn" style={{ cursor: 'pointer' }}>
                                        <i className="fas fa-paperclip" />
                                    </label>

                                    <div className="chat-footer-innr" style={{ position: 'relative' }}>
                                        {filePreview && (
                                            <div className="file-preview" style={{
                                                position: 'absolute',
                                                bottom: '100%',
                                                left: '0',
                                                background: '#f0f0f0',
                                                padding: '8px',
                                                borderRadius: '4px',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                {filePreview.startsWith('data:image') ? (
                                                    <img src={filePreview} alt="Preview" style={{ maxHeight: '50px', maxWidth: '100px', marginRight: '8px' }} />
                                                ) : (
                                                    <span style={{ marginRight: '8px' }}><i className="fas fa-file"></i> {selectedFile?.name}</span>
                                                )}
                                                <button
                                                    onClick={removeSelectedFile}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: 'red',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <i className="fas fa-times"></i>
                                                </button>
                                            </div>
                                        )}
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Type a message"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                                        />
                                        <button type="button" onClick={sendMessage}>
                                            <i className="fas fa-paper-plane" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default Chat
